import PropTypes from 'prop-types'
import classNames from 'classnames'

import { processText } from '@aytm/app/stats/page/components/lib/utils'

import ImagePopup from '@aytm/app/stats/components/image-popup/ImagePopup'
import { BlockContent as OeBlock } from '@aytm/app/stats/page/question-views/oe/Block'

import style from '@aytm/app/stats/page/question-views/oex/components/styles/Items.module.scss'

// A variant is only worth expanding once it has verbatims behind it.
export const isCollapsable = (item, type) => Boolean(item && (item.comments || ('oex' === type && item.positive)))

// The row an answer variant shows while it is closed: what it says, its image, and the expander.
// The image popup belongs here - it is opened by this row's own thumbnail.
export const ItemHeader = ({ item, type, answerLabels, collapsed, expandable }) => {
  const { position, text, image } = item

  return (
    <div className={style.description}>
      {image?.original ? (
        // the popup draws the thumbnail itself and opens on hover; the row toggles on click, so the
        // click is stopped here to keep inspecting an image from collapsing the row
        <div className={style.thumbnail} onClick={event => event.stopPropagation()}>
          <ImagePopup image={image} width={24} height={24} />
        </div>
      ) : null}

      {undefined === text ? null : (
        <span className={style.title}>
          {'hide' === answerLabels ? null : `A${position}: `}
          {/* processText marks up logic, piping and aliases, so the title carries its html */}
          <span dangerouslySetInnerHTML={{ __html: processText(text) }} />
        </span>
      )}

      {expandable && isCollapsable(item, type) ? (
        <span className={classNames(style.expand, { [style.expandOpen]: !collapsed })}>
          <i className="icon-aytmfd-chevron-bracket" />
        </span>
      ) : null}
    </div>
  )
}

// What an open variant expands to: the whole open-ended block for its verbatims. The props are
// resolved by the shell that owns this variant's report params, so a variant it has not built
// one for has nothing to draw.
export const ItemBody = ({ oeProps }) => (oeProps ? <OeBlock {...oeProps} /> : null)

ItemHeader.displayName = 'OexItemHeader'
ItemBody.displayName = 'OexItemBody'

ItemHeader.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string,
  answerLabels: PropTypes.string,
  collapsed: PropTypes.bool,
  expandable: PropTypes.bool
}

ItemBody.propTypes = {
  oeProps: PropTypes.object
}
